import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";



const Table10 = ({ setKhataratNashiAzKar, khataratNashiAzKar, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const [data, setData] = useState([])
  const { setGreadingScore } = useContext(jobContext)

  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.khataratNashiAzKar;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 12, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 20, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 28, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 36, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 40, isSelected: masouliat.value == 4 },
      ]

      setData(masouliatData)

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setKhataratNashiAzKar(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "khataratNashiAzKar": selectedItem }))
    }
  }, [reload])
  return (
    <div>
      <Row type={1}>
        <Column>سطح 1</Column>
        <Column>سطح 2</Column>
        <Column>سطح 3</Column>
        <Column>سطح 4</Column>
        <Column>سطح 5</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          صدمات یا جراحات
          سطحی و عمقی
        </Column>
        <Column paddingY={30}>
          نقص عضو جزئی
        </Column>
        <Column paddingY={30}>
          امراض جلدی،
          ریوی، عصبی،
          واریس، دیسک و
          روماتیسم
        </Column>
        <Column paddingY={30}>
          نقص عضو کلی
        </Column>
        <Column paddingY={30}>
          از کار افتادگی
        </Column>
      </Row>
      {/* <Row type={3}>
        <Column>کم </Column>
        <Column>- </Column>
        <Column>- </Column>
        <Column>- </Column>
        <Column>- </Column>
      </Row> */}
      <Row type={2}>
        <Column isActive={khataratNashiAzKar == 12}>12</Column>
        <Column isActive={khataratNashiAzKar == 20}>20</Column>
        <Column isActive={khataratNashiAzKar == 28}>28</Column>
        <Column isActive={khataratNashiAzKar == 36}>36</Column>
        <Column isActive={khataratNashiAzKar == 40}>40</Column>
      </Row>
      <Row type={5}>
        <Column> امتیاز شغل:</Column>
        <Column isActive={true} size={2}>
          {khataratNashiAzKar}
        </Column>
      </Row>
    </div>
  );
};

export default Table10;
